import { set_auth, getCookie } from '@/router/index.js';
import { get_domain_style } from '@/main';

export default {
  name: 'LoginView',
  data: () => ({
    form: {
      email: '',
      password: '',
    },
    password_visible: false,
    errors: {},
    client_types: [],
    is_cloud_domain: true,
    is_internal: true,
    csrfToken: '',
    loading: false,
    microsoft_loading: false,
    microsoft_signup_loading: false,

  }),

  computed: {
    styleConfig() {
      return get_domain_style();
    },

    microsoft_error() {
      return this.$route.query.microsoft_error || '';
    },

    next_url() {
      const next = this.$route.query.next;
      return typeof next === 'string' && next.startsWith('/') && !next.startsWith('//')
        ? next
        : '';
    },
  },

  mounted() {
    const current_domain = window.location.hostname;
    this.is_cloud_domain = !current_domain.includes('cloud');
    this.is_internal = !current_domain.includes('1campus');
    this.show_microsoft_error();
  },
  methods: {
    password_visibility() {
      this.password_visible = !this.password_visible;
    },

    show_microsoft_error() {
      if (this.microsoft_error) {
        this.$notyf.info(this.microsoft_error);
      }
    },

    sign_in_with_microsoft() {
      this.microsoft_loading = true;

      window.location =
        process.env.VUE_APP_API_BASE_URL +
        '/aic_one_api/microsoft_sso/api/microsoft_login_api/';
    },

    sign_up_with_microsoft() {
      this.microsoft_signup_loading = true;

      window.location =
        process.env.VUE_APP_API_BASE_URL +
        '/aic_one_api/microsoft_sso/api/microsoft_signup_api/';
    },

    validate_email(email) {
      const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return re.test(email);
    },

    validate_form() {
      let is_valid = true;
      const email = this.form.email.trim();
      if (!email || !this.validate_email(email)) {
        this.$notyf.error('Invalid email address');
        is_valid = false;
      }
      if (!this.form.password) {
        this.$notyf.error('Please enter a password');
        is_valid = false;
      }
      return is_valid;
    },

    async fetch_roles() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_all_roles/';
      try {
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrfToken

           },
        });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();
        if (data.status === 'success') {
          this.roles = data.data;
        } else {
          this.$notyf.info('Failed to fetch roles');

        }
      } catch (error) {
        this.$notyf.info('Error fetching roles');

      }
    },


    async submit_form() {
      if (!this.validate_form()) {
        this.loading = false;
        return;
      }
      this.loading = true;

      const payload = {
        username: this.form.email,
        password: this.form.password,
      };

      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/user_login/';
      const cookie_url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_csrf_token/';

      try {
         await fetch(cookie_url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-Page-URL': window.location.href,
            'X-CSRFToken': this.csrfToken,
          },
        });
        this.csrfToken = getCookie('csrftoken');

        const res = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-Page-URL': window.location.href,
            'X-CSRFToken': this.csrfToken,
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();

        if (data.status === 'success') {
          set_auth(data.token, data.user.id);
          localStorage.setItem('otp_required', '1');
          localStorage.setItem('otp_verified', '0');
          this.$router.push({
            path: '/otp',
            query: this.next_url ? { next: this.next_url } : {},
          });
        } else {
          const resp = data || {};
          if (res.status === 403 && resp?.status === 'require_password_reset') {
            const user_id = resp?.data?.user_id;
            const token = resp?.data?.token;
            set_auth(token, user_id);
            this.$router.push('/first_time_login');
            return;
          }

          let errorMessage = 'An error occurred. Please try again.';
          if (resp?.message) {
            errorMessage = resp.message;
          }
          this.$notyf.info(errorMessage);
        }
      } catch (err) {
        // Network or JSON parse errors
        this.$notyf.info('A network error occurred. Please try again. ');

      } finally {
        this.loading = false;
      }
    }

  }

}
